import React from 'react';
import { Slider } from 'components/Slider/Slider';
import './HomeLoanMobileFilter.scss';
import { commafy } from 'helpers/number';
import FilterAndSortButton from 'components/FilterAndSortButton';
import FilterModal from 'components/FilterModal';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { DropDown } from 'components/form/DropDown';
import { RadioGroup } from 'components/RadioGroup/RadioGroup';

const FilterModalContent = props => {
  const loanType =
    typeof props.loanType === 'string' ? props.loanType : props.loanType[0];

  return (
    <>
      <Row fullWidth>
        <Label className="Subtitle-1 margB8">Sort by</Label>
        <DropDown
          id="sort-by"
          list={props.sortList}
          value={props.currentSortType}
          onChange={e => props.setCurrentSortType(e)}
          label="Sort by"
          defaultValue={props.sortList[0]}
          placeholder="Sort by"
          fullWidth
        />
      </Row>
      <Row fullWidth>
        <Label className="Subtitle-1 margT24" for="slider">
          Loan Amount
        </Label>

        <div className="fontGray400 text-center text-28 padB4">
          ${commafy(props?.currentLoanAmount || props?.loanAmount)}
        </div>

        <Slider
          min={props.homeLoanMinimum}
          max={props.homeLoanMaximum}
          step={props.SLIDER_STEP}
          value={props.currentLoanAmount}
          className="HomeLoanfilter-slider"
          size="big"
          fullWidth
          onChange={props.setCurrentLoanAmount}
          onAfterChange={props.handleSliderUp}
        />
      </Row>

      <Row fullWidth>
        <Label className="Subtitle-1 margT24 margB8">Loan Type</Label>
        <RadioGroup
          customClass="flexRadio"
          radioClass="margB18"
          onChange={props.setLoanType}
          options={props.optionsForLoanType}
          value={loanType}
        />
      </Row>
    </>
  );
};

const HomeLoanFilter = props => {
  return (
    <div className="HomeLoan-marketplacefilter-mobile">
      <FilterAndSortButton {...props} />
      <FilterModal
        showModal={props.showModal}
        onCancelFilter={props.hideModal}
        onApplyFilter={props.onApplyFilter}
        onResetFilter={props.onResetFilter}
        showResetButton={true}
      >
        <FilterModalContent {...props} />
      </FilterModal>
    </div>
  );
};

export default HomeLoanFilter;
